import { useContext } from "react";
import { LoadingStateContext } from "../context/LoadingStateContext.js";
const useLoadingStateContext = ()=>{
    const context = useContext(LoadingStateContext);
    if (void 0 === context || void 0 === context.isLoading) throw new Error('useLoadingStateContext must be used within a LoadingStateProvider');
    return context;
};
export { useLoadingStateContext };
